import { render, staticRenderFns } from "./services-detail-table-panel.vue?vue&type=template&id=54444626&scoped=true&lang=pug"
import script from "./services-detail-table-panel.vue?vue&type=script&lang=js"
export * from "./services-detail-table-panel.vue?vue&type=script&lang=js"
import style0 from "./services-detail-table-panel.vue?vue&type=style&index=0&id=54444626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54444626",
  null
  
)

export default component.exports